// Utility để lấy backend URL linh hoạt cho mọi component
export const getBackendUrl = () => {
  // 1. Kiểm tra environment variable từ build time
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL.replace('/api', '');
  }
  
  // 2. Tự động phát hiện dựa trên domain hiện tại
  const currentHost = window.location.hostname;
  const currentProtocol = window.location.protocol;
  const currentPort = window.location.port;
  
  // Development environment
  if (currentHost === 'localhost' || currentHost === '127.0.0.1') {
    return 'http://localhost:5000';
  }
  
  // Production environment - same domain
  if (currentProtocol === 'https:') {
    return `${currentProtocol}//${currentHost}`;
  } else {
    const portSuffix = currentPort && currentPort !== '80' ? `:${currentPort}` : '';
    return `${currentProtocol}//${currentHost}${portSuffix}`;
  }
};

// Utility để lấy API URL (với /api suffix)
export const getApiUrl = () => {
  const backendUrl = getBackendUrl();
  return `${backendUrl}/api`;
};

// Utility để lấy uploads URL
export const getUploadsUrl = (path = '') => {
  const backendUrl = getBackendUrl();
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${backendUrl}/${cleanPath}`;
};

// Chuẩn hóa nguồn file từ DB/API:
// - hỗ trợ full URL
// - hỗ trợ path tuyệt đối Windows/Linux
// - hỗ trợ uploads/... hoặc /uploads/...
// - fallback về tên file
export const normalizeDocumentSource = (source) => {
  if (!source || typeof source !== 'string') return '';

  const normalized = source.trim().replace(/\\/g, '/');
  if (!normalized) return '';

  if (normalized.startsWith('http://') || normalized.startsWith('https://')) {
    return normalized;
  }

  // Có chứa segment /uploads/... bên trong path tuyệt đối
  const uploadsIndex = normalized.toLowerCase().indexOf('/uploads/');
  if (uploadsIndex >= 0) {
    return normalized.slice(uploadsIndex + 1); // bỏ dấu '/' đầu
  }

  if (normalized.startsWith('uploads/')) {
    // Dữ liệu lỗi kiểu: uploads/documents/C:/.../file.ext
    if (/^uploads\/documents\/[a-zA-Z]:\//.test(normalized)) {
      const parts = normalized.split('/').filter(Boolean);
      const fileOnly = parts[parts.length - 1] || '';
      return fileOnly ? `uploads/documents/${fileOnly}` : 'uploads/documents';
    }
    return normalized;
  }

  // Path tuyệt đối Windows/Linux -> lấy tên file
  if (/^[a-zA-Z]:\//.test(normalized) || normalized.startsWith('/')) {
    const parts = normalized.split('/').filter(Boolean);
    return parts[parts.length - 1] || '';
  }

  return normalized;
};

// Utility để lấy documents URL
export const getDocumentUrl = (fileName) => {
  if (!fileName) return '';
  
  const backendUrl = getBackendUrl();
  const normalizedSource = normalizeDocumentSource(fileName);
  if (!normalizedSource) return '';
  
  // Nếu đã là URL đầy đủ
  if (normalizedSource.startsWith('http://') || normalizedSource.startsWith('https://')) {
    return normalizedSource;
  }
  
  // Nếu đã chứa uploads path
  if (normalizedSource.startsWith('uploads/')) {
    return `${backendUrl}/${normalizedSource}`;
  }
  
  // Mặc định thêm vào uploads/documents/
  return `${backendUrl}/uploads/documents/${normalizedSource}`;
};
